import React from 'react';
import { relatedNews } from '../data/relatedNews';
export function RelatedNews() {
  return <section aria-labelledby="relacionados-titulo" className="border-t border-brand-blush bg-paper" data-id="element-184" data-mp="2vagw0nugpqcs">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6" data-id="element-185" data-mp="2qjqn50mtv5dc">
        <h2 id="relacionados-titulo" className="font-sans text-sm font-bold uppercase tracking-[0.18em] text-ink-soft" data-id="element-186" data-mp="2qhxh9nk1gp6e">
          También te puede interesar
        </h2>
        <div className="mt-6 grid gap-x-8 gap-y-10 md:grid-cols-3" data-id="element-187" data-mp="2gjq2nbd82j7k">
          {relatedNews.map(article => <article key={article.id} className="flex h-full flex-col" data-id="element-188" data-mp="27leh3nr7qblz">
              <a href="#top" className="group block overflow-hidden rounded-sm bg-neutral-200" aria-label={article.title} data-id="element-189" data-mp="27lo3z2gyo2ng">
                <img src={article.image} alt={article.imageAlt} className="aspect-[3/2] w-full object-cover transition-transform duration-200 ease-out group-hover:scale-[1.03]" loading="lazy" data-id="element-190" data-mp="5tj9bj82ur91" />
              </a>
              <p className="mt-3 font-sans text-[0.68rem] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-191" data-mp="1l3zjhrelhnfl">
                {article.category}
              </p>
              <h3 className="mt-2 font-serif text-[1.2rem] font-semibold leading-snug text-ink" data-id="element-192" data-mp="1c1881rlpyrny">
                <a href="#top" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-193" data-mp="1zqsskexitwzc">
                  {article.title}
                </a>
              </h3>
              <p className="mt-auto pt-3 font-sans text-xs text-ink-muted" data-id="element-194" data-mp="1q0q0cgy84n22">
                Redacción Mi Cocina Natural
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}